"use client";
import getBrowserFingerprint from "get-browser-fingerprint";
import { createContext, useContext, useEffect } from "react";
// import { usePathname } from "next/navigation";
import { useLocation } from "react-router-dom";

import { postTracking } from "../../service";

const TrackingContext = createContext<{
  handleTracking: (url: string) => void;
} | null>(null);

export const TrackingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // const pathname = usePathname(); // Lấy URL hiện tại
  const { pathname } = useLocation(); // Lấy URL hiện tại
  // Hàm gọi API tracking
  const handleTracking = async (url: string) => {
    try {
      const fingerprint = await getBrowserFingerprint();
      const deviceId = fingerprint.toString();

      // Gọi API tracking
      await postTracking({ url, deviceId });

      // console.log(📍 Tracked: ${url}, Device ID: ${deviceId});
    } catch (error) {
      console.error("❌ Tracking API failed:", error);
    }
  };

  console.log(pathname, "aaasa");

  useEffect(() => {
    if (typeof window !== "undefined") {
      const fullUrl = window.location.origin + window.location.pathname;
      // Kiểm tra nếu là trang 404
      const isNotFoundPage =
        document.title.includes("404") ||
        pathname === "/404" ||
        pathname === "/not-found";

      if (!isNotFoundPage) {
        handleTracking(fullUrl);
      }
    }
  }, [pathname]);

  return (
    <TrackingContext.Provider value={{ handleTracking }}>
      {children}
    </TrackingContext.Provider>
  );
};

// Hook để sử dụng Tracking trong component
export const useTracking = () => {
  const context = useContext(TrackingContext);
  if (!context)
    throw new Error("useTracking must be used within a TrackingProvider");
  return context;
};
